import { useEffect, useMemo, useState } from "react";
import { ArrowLeft, ArrowRight, MonitorPlay, X } from "lucide-react";
import { Link, useSearchParams } from "react-router-dom";
import { Toaster, toast } from "sonner";
import { PLANTILLAS } from "../templates/registry";
import { TIPOS_EVENTO } from "../templates/registry";
import Presentacion from "../catalogo/Presentacion";
import "../catalogo/catalogo.css";
import "./plantillas-page.css";

function CatalogCard({ plantilla, onOpen }) {
  const [paleta, setPaleta] = useState(plantilla.paletas[0]);
  return <article className="catalogo-card" data-testid={`landing-catalog-card-${plantilla.id}`}>
    <div className="catalogo-card-media">
      <img src={plantilla.miniaturas?.[paleta.clave] || plantilla.miniatura} alt={`Vista previa de ${plantilla.nombre}`} loading="lazy" />
      <span className="catalogo-card-tipo">{plantilla.tipoEtiqueta}</span>
    </div>
    <div className="catalogo-card-cuerpo">
      <h2 className="catalogo-card-nombre">{plantilla.nombre}</h2>
      <p className="catalogo-card-desc">{plantilla.descripcion}</p>
      <div className="catalogo-card-pie">
        <div className="catalogo-card-paletas" aria-label="Paletas disponibles">
          {plantilla.paletas.map((item) => <button key={item.clave} type="button" className={`catalogo-card-muestra${paleta.clave === item.clave ? " catalogo-card-muestra--activa" : ""}`} style={{ background: item.tema.colores.primario }} aria-label={`Previsualizar ${item.nombre}`} title={item.nombre} onClick={() => setPaleta(item)} />)}
        </div>
        <button type="button" className="catalogo-card-boton" onClick={() => onOpen(plantilla.id, paleta.clave)} data-testid={`landing-catalog-open-${plantilla.id}`}>Ver demostración <ArrowRight size={15} /></button>
      </div>
    </div>
  </article>;
}

function Demo({ plantilla, initialPalette, onBack }) {
  const [paleta, setPaleta] = useState(plantilla.paletas.find((item) => item.clave === initialPalette) || plantilla.paletas[0]);
  const datos = useMemo(() => ({ ...plantilla.datosEjemplo, tema: paleta.tema }), [plantilla, paleta]);
  const Component = plantilla.Componente;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="landing-template-demo">
    <div className="landing-template-demo-bar">
      <button type="button" onClick={onBack} className="landing-template-back" data-testid="landing-template-back"><ArrowLeft size={16} /> Catálogo</button>
      <span>{plantilla.tipoEtiqueta} · {plantilla.nombre}</span>
      <div className="landing-template-palettes" role="group" aria-label="Elegir paleta">
        {plantilla.paletas.map((item) => <button key={item.clave} type="button" className={paleta.clave === item.clave ? "active" : ""} onClick={() => setPaleta(item)} aria-label={`Usar paleta ${item.nombre}`}><i style={{ background: item.tema.colores.primario }} />{item.nombre}</button>)}
      </div>
    </div>
    <Component datos={datos} desactivarScrollSuave onConfirmarAsistencia={() => toast.info("Esta es una demostración. La confirmación se realiza desde la invitación publicada.")} onAbrirLibroFirmas={() => toast.info("Este módulo se conecta desde la invitación publicada.")} onAbrirAlbumColaborativo={() => toast.info("Este módulo se conecta desde la invitación publicada.")} />
  </div>;
}

export default function PlantillasPage() {
  const [params, setParams] = useSearchParams();
  const initial = params.get("plantilla");
  const [tipo, setTipo] = useState("todos");
  const [demo, setDemo] = useState(initial ? { id: initial, paleta: params.get("paleta") } : null);
  const filtradas = tipo === "todos" ? PLANTILLAS : PLANTILLAS.filter((item) => item.tipoEvento === tipo);
  const open = (id, paleta) => { setDemo({ id, paleta }); setParams({ plantilla: id, paleta }); };
  if (demo) {
    const plantilla = PLANTILLAS.find((item) => item.id === demo.id);
    if (plantilla) return <Demo plantilla={plantilla} initialPalette={demo.paleta} onBack={() => { setDemo(null); setParams({}); }} />;
  }
  return <main className="landing-catalog-page" data-testid="landing-catalog-page">
    <header className="landing-catalog-header">
      <Link to="/#plantillas" className="landing-catalog-brand">Pro360 · Invitaciones Digitales Plus</Link>
      <Link to="/" className="landing-catalog-home">Volver al sitio</Link>
      <p className="landing-catalog-eyebrow">Colección de diseños</p>
      <h1>Elegí el estilo de tu invitación</h1>
      <p>Explorá las propuestas, abrí una demostración y encontrá la composición que mejor acompaña tu evento.</p>
      <button type="button" className="landing-presentation-button" onClick={() => setDemo({ presentation: true })}><MonitorPlay size={16} /> Iniciar presentación</button>
      <nav className="landing-catalog-filters" aria-label="Filtrar plantillas">
        {TIPOS_EVENTO.map((item) => <button key={item.id} type="button" className={tipo === item.id ? "active" : ""} onClick={() => setTipo(item.id)}>{item.etiqueta}</button>)}
      </nav>
    </header>
    <div className="landing-catalog-grid">{filtradas.map((item) => <CatalogCard key={item.id} plantilla={item} onOpen={open} />)}</div>
    <footer className="landing-catalog-footer"><Link to="/">Pro360</Link><span>Diseños que se adaptan a tu historia.</span></footer>
    {demo?.presentation && <Presentacion alSalir={() => setDemo(null)} />}
  </main>;
}
